import { ReactElement } from 'react';
import styles from './ui-spinner.module.scss';
import { charcoal } from '../../styles';

const SIZE = 16;

type UISpinnerProps = {
    size?: number;
    color?: string;
};

export function UISpinner(props: UISpinnerProps): ReactElement {
    const { size = SIZE, color = charcoal } = props;

    const classNames = [styles.loader];

    return (
        <div
            className={classNames.join(' ')}
            style={{
                width: size,
                height: size,
                borderTop: `2px solid ${color}`
            }}
        />
    );
}
